import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import axios from 'axios'
import './sentry.js'
import { OverlayProvider } from 'react-aria'

// Auto-reload on Vite chunk loading errors (stale cache after rebuild)
window.addEventListener('error', (e) => {
  const isChunkError = e.message?.includes?.('Failed to fetch dynamically imported module') ||
                       e.message?.includes?.('error loading dynamically imported module');
  if (isChunkError && !sessionStorage.getItem('_chunk_reload')) {
    sessionStorage.setItem('_chunk_reload', '1');
    window.location.reload();
  }
});
window.addEventListener('unhandledrejection', (e) => {
  const isChunkError = e.reason?.message?.includes?.('Failed to fetch dynamically imported module') ||
                       e.reason?.message?.includes?.('error loading dynamically imported module');
  if (isChunkError && !sessionStorage.getItem('_chunk_reload')) {
    sessionStorage.setItem('_chunk_reload', '1');
    window.location.reload();
  }
});

// Clear chunk reload guard once app starts successfully
sessionStorage.removeItem('_chunk_reload');

// Configure axios to send credentials with all requests
axios.defaults.withCredentials = true

// Add response interceptor to handle expired tokens
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized (expired/invalid token)
    if (error.response?.status === 401) {
      const errorMessage = error.response?.data?.message || error.response?.data?.error;
      
      // Check if it's a token expiration error
      if (errorMessage?.toLowerCase().includes('expired') || 
          errorMessage?.toLowerCase().includes('session')) {
        alert('Your session has expired. Please log in again.');
        // Clear any stored data
        localStorage.clear();
        sessionStorage.clear();
        // Redirect to login
        window.location.href = '/Login';
      }
    }
    return Promise.reject(error);
  }
);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <OverlayProvider>
      <App />
    </OverlayProvider>
  </React.StrictMode>,
)
